module.exports = __webpack_public_path__ + "static/media/logo-sebrae.07517d73.svg";